import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "../datastore/slices/globaldata";

export const store = configureStore({
  reducer: {
    global: globalReducer,
  },
});
